<template>
  <div
    class="cp"
    :class="{
      'is-invalid': validate && !isValid,
      'disabled': disabled,
    }"
    :style="{
      'margin-bottom': validate && !isValid ? '20px' : '',
    }"
  >
    <div class="cp-field">
      <button
        :id="`cp-field-${_uid}`"
        :disabled="disabled"
        :style="{ background: hex || defaultColor }"
        class="cp-sample"
        @click.prevent
      ></button>
      <span @click.stop="toggle">
        <c-input
          ref="input"
          v-model="hex"
          class="cp-input"
          :placeholder="defaultColor"
          :disabled="disabled"
          :max-length="7"
          :clearable="true"
          :required-mark="true"
          :required="validate && !isValid && 'Неверный формат'"
          :required-message="validate && !isValid && 'Неверный формат'"
        />
      </span>
    </div>

    <b-popover
      ref="color-pallete"
      placement="bottom"
      custom-class="cp-palette"
      :target="`cp-field-${_uid}`"
      @show="onShow"
    >
      <div @click.stop>
        <chrome-picker ref="picker" v-model="color" class="picker"></chrome-picker>
      </div>
    </b-popover>
  </div>
</template>

<script>
import { Chrome } from "vue-color";

import Input from "@/components/controls2/Input";

export default {
  name: "color-picker",
  components: {
    "chrome-picker": Chrome,
    "c-input": Input,
  },

  props: ["value", "validate", "defaultColor", "disabled"],
  data: () => ({
    isOpen: false,
    hex: "",
    color: {
      source: "hex",
      hex: "",
    },
  }),
  computed: {
    isValid() {
      if (!this.color.hex) return true;
      const hexPattern = /#([A-F]|[a-f]|\d){6}$/;
      return hexPattern.test(this.color.hex);
    },
  },

  watch: {
    color(v) {
      this.hex = v.hex;
      this.$emit("input", v.hex);
    },
    hex(v) {
      this.color = {
        source: "hex",
        hex: v,
      };
    },
    value(v) {
      if (v !== this.color.hex) {
        this.hex = v;
        this.color = {
          source: "hex",
          hex: v,
        };
      }
    },
    isOpen(v) {
      if (v) {
        this.imitateClick();
        return;
      }
      this.$refs["color-pallete"].$emit("close");
    },
  },

  created() {
    this.color = {
      source: "hex",
      hex: this.value,
    };

    this.hex = this.value;

    this._cb = () => {
      this.isOpen = false;
    };

    // document.addEventListener("click", this._cb);
  },

  beforeDestroy() {
    // document.removeEventListener("click", this._cb);
  },

  methods: {
    onShow() {
      setTimeout(() => {
        this.$refs.input.focusOnInput();
      }, 0);
    },
    toggle() {
      if (!this.isOpen) {
        this.isOpen = true;
        setTimeout(() => {
          this.$refs.input.focusOnInput();
        }, 0);
        return;
      }

      this.isOpen = false;
    },
    imitateClick() {
      const button = document.getElementById(`cp-field-${this._uid}`);
      button.click();
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/vars";
.popover {
  z-index: 3001 !important;
}
.cp {
  position: relative;

  &-field {
    display: flex;
    align-items: flex-end;
  }

  &-input {
    flex-shrink: 0;
    width: 124px;
  }

  .c-input-action_clear {
    margin-top: -2px;
  }

  &-sample {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 1px solid #d3d8df;
    margin-right: 16px;
    flex-shrink: 0;
    margin-bottom: 5px;
  }

  &.is-invalid {
    .c-input-border {
      color: $color-error;
    }
  }

  .cp-error {
    margin-top: 4px;
  }
}
.cp-palette {
  .popover-body {
    padding: 0;
  }

  .vc-chrome {
    &-alpha-wrap,
    &-fields-wrap {
      display: none;
    }

    &-hue-wrap {
      margin-top: 10px;
    }
  }
}
</style>
